<!-- 登录 -->
<template>
  <div class="login">
    <div class="loginArea">
      <div class="title">用户登录</div>
      <div class="userName">
        <el-input placeholder="请输入用户名" class="loginInput" v-model="username"></el-input>
      </div>
      <div class="userName">
        <el-input placeholder="请输入密码" class="loginInput" v-model="password" type="password" show-password></el-input>
      </div>
      <!--验证码-->
      <div class="code">
        <el-input
          v-model="code"
          auto-complete="off"
          placeholder="验证码"
          style="width: calc(100% - 110rem)"
        >
          <!-- <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" /> -->
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </div>
      <div class="logBtn">
        <el-button class="preserveHandle" type="primary" @click="login">登 录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/user';
import { setToken } from '@/utils/auth';
import { getCodeImg } from "@/api/user";
export default {
  name: "FieldsOperate",
  data() {
    return {
      username: '',
      password: '',
      code:'',
      uuid:'',
      // 验证码开关
      captchaEnabled: true,
      codeUrl: "",
    };
  },

  methods: {
    login() {
      login({ account: this.username, password: this.password, code:this.code, uuid:this.uuid }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          const { realName, token } = res.data;
          setToken(token)
          this.$store.commit('updateUserInfo', { realName, token })
          sessionStorage.setItem('name', realName)
          this.$router.push({
            path: '/'
          })
        } else {
          this.$message.error(res.info);
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.uuid = res.uuid;
        }
      });
    },
  },
  mounted() { 
    this.getCode();
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url(@/assets/images/login_backguound.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.loginArea {
  width: 340rem;
  height: 300rem;
  position: absolute;
  left: calc(50vw - 340rem / 2);
  top: calc(50vh - 300rem / 2);
  background: white;
  border-radius: 10rem;
  overflow: hidden;
  box-shadow: 0 4rem 16rem 4rem #0bae6a;
  padding: 20rem 60rem;
  box-sizing: content-box;

  .title {
    height: 45rem;
    font-size: 24rem;
    color: var(--primary-color);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20rem;
  }

  .userName {
    margin-bottom: 20rem;
  }
  .code{
    display: flex;
    height: 48rem;
    margin-bottom: 20rem;
  }
  .login-code {
    height: 28rem;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  ::v-deep .el-input__inner{
    height: 40rem;
  }
}
.login-code-img{
  height: 40rem;
}
.preserveHandle {

  width: 100%;
  height: 45rem;
  padding: 0;
  background-image: var(--background-image);
  border-color: var(--primary-color);

}

.preserveHandle:hover {
  padding: 0;
  background-image: var(--background-image);
  border-color: var(--primary-color);
}
</style>
